<div class="">
  <h3>{{ 'HOME_BRANCHES.TITLE' | translate }}</h3>
  <p class="subtitulo pb-4">
    {{ 'LANDING.PROMOTIONS.SUBTITLE' | translate }}
  </p>
</div>
<div class="divisa-row order-wrapper">
  <div class="divisa-col-sm-12 divisa-col-md-8 my-auto only">
    <div class="card border-success mb-3" *ngIf="sucursales">
      <div class="card-header">
        <h6 class="mb-0">
          {{ sucursales[sucursalSelectet].branchName }} -
          {{ sucursales[sucursalSelectet].address.city }}
        </h6>
      </div>
      <div class="">
        <div #map style="width: 100%; height: 350px"></div>
      </div>
      <div class="card-footer divisa-row">
        <img
          class="divisa-col-2 divisa-col-lg-1 my-auto"
          style="max-width: 40px; max-height: 40px"
          src="./assets/img/circle-icon.svg"
          alt=""
        />
        <p class="divisa-col-10 divisa-col-lg-7 pl-3 my-auto my-mb-0">
          {{ sucursales[sucursalSelectet].address.street }}
        </p>

        <div
          class="divisa-col-8 divisa-col-lg-3 divisa-space-between mx-auto my-2"
        >
          <a
            mat-fab
            [matTooltip]="'LANDING.SUCURSALES.TOOLTIP_CALL' | translate"
            color="accent"
            class="icon-sm-button"
            href="tel:{{ getBranchPhone() }}"
          >
            <mat-icon svgIcon="call"></mat-icon>
          </a>
          <a
            mat-fab
            [matTooltip]="'LANDING.SUCURSALES.TOOLTIP_WHATSAPP' | translate"
            color="accent"
            class="icon-sm-button"
            target="_blank"
            href="https://wa.me/{{ getBranchWhatsapp() }}"
          >
            <i class="fa-brands fa-whatsapp" style="font-size: 23px"></i>
          </a>
          <a
            mat-fab
            [matTooltip]="'LANDING.SUCURSALES.TOOLTIP_MAP' | translate"
            color="accent"
            class="icon-sm-button"
            target="_blank"
            href="https://www.google.com/maps/search/?api=1&query={{
              sucursales[sucursalSelectet].address.latitude
            }}%2C{{ sucursales[sucursalSelectet].address.longitude }}"
          >
            <mat-icon svgIcon="room"></mat-icon>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="divisa-col-sm-12 divisa-col-md-4 mx-auto my-auto my-mb-0 px-3">
    <div
      *ngFor="let sucursal of sucursales; let i = index"
      class="divisa-col-12 px-0"
    >
      <button
        class="btn btn-outline-light my-3 divisa-col-12"
        (click)="selectSucursal(i)"
        [ngClass]="{ active: sucursalSelectet == i }"
      >
        {{ sucursal.branchName }}
      </button>
    </div>
  </div>
</div>
